const React = require('react');
const withState = require('../../utils/withState');


module.exports = (open$, render) => {
  return withState((setState) => {
    return (state, props) => {
      const {
        open,
        animate,
      } = state;
      const options = open || animate || state.lazyOpen;

      return options ? (
        <div
          className={`fixed s z10 o0 ff$2 dn ovxH ovyA bg181A1C.95 cF
            o100.active ` + (open && animate ? ' active' : '')}
        >
          <div
            className={'layoutRow fhaC fvaC w hmin rlv p10 '
              + (props.className || '')}
          >{render(options, props, state, setState)}</div>
        </div>
      ) : null;
    };
  }, {
    open: open$,
    animate: open$.delay(50),
    lazyOpen: open$.delay(500),
  });
};
